var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRefreshDouble(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "refresh-double"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Vector"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.99927 2.29297C6.00261 2.29297 2.7157 5.33512 2.32902 9.22972C2.29492 9.57321 1.98882 9.82402 1.64533 9.78991C1.30184 9.75581 1.05103 9.44971 1.08514 9.10622C1.53467 4.57862 5.35368 1.04297 9.99927 1.04297C13.6737 1.04297 16.8301 3.25513 18.2119 6.41774C18.3501 6.73404 18.2057 7.10249 17.8894 7.24069C17.5731 7.37889 17.2047 7.23451 17.0665 6.9182C15.8764 4.19446 13.1592 2.29297 9.99927 2.29297Z",
    fill: "#2E2E38"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.3326 1.8763C18.6778 1.8763 18.9576 2.15612 18.9576 2.5013V6.16797C18.9576 6.78929 18.4539 7.29297 17.8326 7.29297H14.1659C13.8208 7.29297 13.5409 7.01315 13.5409 6.66797C13.5409 6.32279 13.8208 6.04297 14.1659 6.04297H17.7076V2.5013C17.7076 2.15612 17.9874 1.8763 18.3326 1.8763Z",
    fill: "#2E2E38"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.0404 17.7096C14.0371 17.7096 17.324 14.6675 17.7107 10.7729C17.7448 10.4294 18.0509 10.1786 18.3944 10.2127C18.7378 10.2468 18.9886 10.5529 18.9545 10.8964C18.505 15.424 14.686 18.9596 10.0404 18.9596C6.36595 18.9596 3.20957 16.7475 1.82776 13.5849C1.68957 13.2686 1.83395 12.9001 2.15025 12.7619C2.46656 12.6237 2.83501 12.7681 2.97321 13.0844C4.16326 15.8081 6.88048 17.7096 10.0404 17.7096Z",
    fill: "#2E2E38"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.70703 18.1263C1.36185 18.1263 1.08203 17.8465 1.08203 17.5013V13.8346C1.08203 13.2133 1.58571 12.7096 2.20703 12.7096H5.8737C6.21888 12.7096 6.4987 12.9895 6.4987 13.3346C6.4987 13.6798 6.21888 13.9596 5.8737 13.9596H2.33203V17.5013C2.33203 17.8465 2.05221 18.1263 1.70703 18.1263Z",
    fill: "#2E2E38"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRefreshDouble);
export default __webpack_public_path__ + "static/media/refresh-double.4dfc2072fda1f0d61c0bef1b9f1594bb.svg";
export { ForwardRef as ReactComponent };